module.exports = __webpack_public_path__ + "static/media/Yannick - ZFE 56 - 2ème.82085283.mp3";